import 'slick-carousel/slick/slick'

export default class AccreditationsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-accreditations-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.each((index, element) => {
                const $slider = $(element);
                const sliderId = $slider.data('slider-id');

                $slider.slick({
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: $('.js-accreditations-slider-previous'),
                    nextArrow: $('.js-accreditations-slider-next'),
                    dots: true,
                    appendDots: $(`.js-accreditations-slider-dots[data-slider-id="${sliderId}"]`),

                    responsive: [
                        {
                            breakpoint: 1280,
                            settings: {
                                slidesToShow: 5,
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 4,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ]
                });
            });
        }

    }

};

new AccreditationsSlider();